module.exports = __webpack_public_path__ + "img/golden_fountain_small.b2843afc.png";